import { combineReducers } from 'redux';
import ids from './ids';
import params from './params';
import selectedIds from './selectedIds';
import total from './total';
export default combineReducers({
    ids: ids,
    params: params,
    selectedIds: selectedIds,
    total: total,
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/reducer/admin/resource/list/index.js
// module id = 1033
// module chunks = 0